import { Defaults } from 'src/app/defaults';

const defaults = new Defaults();
export const SpotPriceChartConfig = {
  spotPriceLineConfig: {
    label: 'SPOT_PRICE_PER_KWH',
    data: [],
    backgroundColor: '#F47E6A',
    borderColor: '#F47E6A',
    tension: 0.4,
    parsing: {
      xAxisKey: 'hour',
      yAxisKey: 'price.spotPrice'
    }
  },
  chargingPriceLineConfig: {
    label: 'CHARGING_PRICE_PER_KWH',
    data: [],
    backgroundColor: defaults.colors.primary,
    borderColor: defaults.colors.primary,
    tension: 0.4,
    parsing: {
      xAxisKey: 'hour',
      yAxisKey: 'price.charginPrice'
    }
  }
};
